export const COMMUNITY_AUTOMATION_TYPES = {
  EVENT: 'EVENT',
  ACTION: 'ACTION'
};

export const COMMUNITY_AUTOMATION_STATUSES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

export const COMMUNITY_EVENT_STEP_NAMES = {
  NOT_OPEN_APP_IN_X_DAYS: 'NOT_OPEN_APP_IN_X_DAYS'
};

export const COMMUNITY_EVENT_STEP_NAMES_LABELS = {
  NOT_OPEN_APP_IN_X_DAYS: 'Not opened the app in x days'
};

export const COMMUNITY_ACTION_STEP_NAMES = {
  SEND_PUSH_NOTIFICATION: 'SEND_PUSH_NOTIFICATION'
};

export const COMMUNITY_ACTION_STEP_NAMES_LABELS = {
  SEND_PUSH_NOTIFICATION: 'Push notification'
};
